/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleUpdateResponse {
    getFixupPrototypeFunction() { return RoleUpdateResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleUpdateResponse>): RoleUpdateResponse {
        let obj = Object.assign(new RoleUpdateResponse(), model);
        RoleUpdateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleUpdateResponse>): RoleUpdateResponse {
        if (!model) return null;
        return RoleUpdateResponse.newInstance(<RoleUpdateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleUpdateResponse) {
        if (!obj) return;

        models.RoleUpdateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleUpdateResponse): boolean {
        Object.setPrototypeOf(obj, RoleUpdateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the updated role
     */
    id: string;

}
